export const parseStringToInt = (stringValue,defaultValue)=>{
    try {
        const res = parseInt(stringValue,);
        if(isNaN(res)) return defaultValue;
        return res;
    } catch (error) {
        return defaultValue;
    }
}